import type { VoidFunctionComponent } from 'react';

import { isFreeTier } from '../../../../../../../../shared/subscriptions';
import { window } from '../../../../../../../globals';
import PaidFeatureGate from '../../../../../../generic/Gates/PaidFeatureGate';
import type { PartialReportConfig } from '../../../../../../../../shared/reports/types';

import { SavedOptions } from './SavedOptions';
import { SavedOptionsLabel } from './SavedOptionsLabel';
import type { SavedOptionApplySource } from './SavedOptions';

import styles from './Option.module.less';

type Props = {
  currentConfig: PartialReportConfig;
  handleSavedOptionApply: (config: PartialReportConfig | null, source?: SavedOptionApplySource) => void;
  isSavedOptionDirty: boolean;
};

/**
 * Container for the Saved Options component that combines the label, tooltip, and dropdown into a single component for
 * easier reuse.
 */
export const SavedOptionsContainer: VoidFunctionComponent<Props> = ({
  currentConfig,
  handleSavedOptionApply,
  isSavedOptionDirty,
}) => {
  const isPaidFeatureGateRestricted = isFreeTier({
    plan: window.user?.organization?.stripe_plan,
    stripePriceLimit: window.user?.organization?.stripePriceLimit,
  });
  return (
    <PaidFeatureGate isRestricted={isPaidFeatureGateRestricted} hidePill>
      <div className={styles.savedOptionsContainer}>
        <SavedOptionsLabel />
        <SavedOptions
          currentConfig={currentConfig}
          onApply={handleSavedOptionApply}
          isSavedOptionDirty={isSavedOptionDirty}
          isRestricted={isPaidFeatureGateRestricted}
        />
      </div>
    </PaidFeatureGate>
  );
};
